import { ChangeDetectionStrategy, HostListener, Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { FatDoctoRef } from 'app/shared/interfaces/fat-docto-ref';
import { PageResult } from 'app/shared/interfaces/page-result';
import { FatDoctoCService } from 'app/shared/services/fat-docto-c.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { FatDoctoC } from '../../../../../shared/interfaces/fat-docto-c';
import { AppConfirmService } from '../../../../../shared/services/app-confirm/app-confirm.service';
import { LancamentoReferPopupComponent } from '../lancamento-refer-popup/lancamento-refer-popup.component';

@Component({
  selector: 'app-lancamento-refer',
  templateUrl: 'lancamento-refer.component.html',
  styleUrls: ['lancamento-refer.component.scss'],
})
export class LancamentoReferComponent implements OnInit, OnDestroy {

  public doctoCForm: FormGroup;

  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  pageObject$: BehaviorSubject<PageResult<FatDoctoRef>> = new BehaviorSubject<PageResult<FatDoctoRef>>(null);
  selectedOrdem = 'NENHUM';
  selectedDirect = 'ASC';
  view = 'module';
  page = 1;
  length = 0;
  pageSize = 10;
  pageEvent = null;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  public searchInput = '';
  searchEntry$: Subject<string> = new Subject<string>();

  lcto: FatDoctoC;
  refs: FatDoctoRef[];

  maskUpper = {
    mask: /^\w\s*/,
    prepare: (str: any) => str.toUpperCase()
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<LancamentoReferComponent>,
    private dialog: MatDialog,
    private confirmService: AppConfirmService,
    private fatDoctoCService: FatDoctoCService,
  ) {
  }

  ngOnInit() {
    console.log('INIT ref');
    this.doctoCForm = this.data.payload;
    this.lcto = this.doctoCForm.value;

    // inicializa paginator com valores retoRnados pela API.
    this.pageObject$.subscribe(
      page => {
        if (page != null) {
          this.length = page.totalElements;
          this.pageSize = page.size;
          this.page = page.number;
        } else {
        }
      });
    // retorna primeira página da pesquisa.
    this.getPage(1, this.pageSize);

    this.debounceTimeSearch();
  }

  /**
 * Retorna a página requerida,
 * @param page numero da página requisitada, primeira página é 1
 * @param pageSize quantidade de itens a serem retornados
 */
  getPage(page: number, pageSize: number) {
    this.fatDoctoCService.getPageDoctoRef(this.lcto?.controle, page, pageSize, this.selectedOrdem
      , this.selectedDirect).subscribe(val => this.pageObject$.next(val));
  }

  /**
  * Retorna a página da pesquisa,
  * @param search valor a ser pesquisada
  * @param page numero da página requisitada, primeira página é 1
  * @param pageSize quantidade de itens a serem retornados
  */
  getSearchPage(search: string, page: number, pageSize: number) {
    if (page === 1) {
      this.paginator.firstPage();
    }
    if (search === null || search === undefined || search.length === 0) {
      this.getPage(1, this.pageSize);
    } else {
      this.fatDoctoCService.getPageSearchDoctoRef(search, this.lcto?.controle, page, pageSize, this.selectedOrdem
        , this.selectedDirect).subscribe(val => this.pageObject$.next(val));
    }
  }


  /**
   *
   * @param event Captura evento de mudança em alguma configuração no paginator e recarrega a lista.
   */
  setPageSizeOptions(event: PageEvent) {
    this.pageSize = event.pageSize;
    if (this.searchInput.length > 0) {
      this.getSearchPage(this.searchInput, event.pageIndex + 1, event.pageSize);
    } else {
      this.getPage(event.pageIndex + 1, event.pageSize);
    }
  }

  searchBy_UsingDebounce(searchString: any) {
    this.searchInput = searchString;
    this.searchEntry$.next(this.searchInput);
  }

  debounceTimeSearch() {
    this.searchEntry$
      .pipe(debounceTime(500))
      .subscribe((s) => this.getSearchPage(s, 1, this.pageSize));
  }

  private viewSize() {
    if (this.view === 'comfy') {
      return 20;
    } else if (this.view === 'module') {
      return 30;
    }
    return 100;
  }

  ngOnDestroy() {
  }

  createLctoRef(lcto: FatDoctoC) {
    this.fatDoctoCService.createDoctoRef().subscribe(ref=>{
      this.editLctoRef(ref, lcto);
    }, err=>{
      this.confirmService.confirm(
        {
          title: `A T E N Ç Ã O !`,
          message: `Não foi Possível criar documento referenciado!\n ` + err,
          error: true
        }
      );
    })
  }

  private editLctoRef(ref: FatDoctoRef, lcto: FatDoctoC) {
    ref.controle = lcto?.controle;
    ref.fatDoctoC = lcto;
    let title = "Documento Referenciado: ";
    let dialogRef: MatDialogRef<any> = this.dialog.open(LancamentoReferPopupComponent, {
      width: '80%',
      disableClose: true,
      data: { title: title + "[ " + (lcto?.controle ?? '') + " - " + (lcto?.nome ?? '') + " ]", payload: ref }
    });
    dialogRef.afterClosed()
      .subscribe(res => {
        this.getPage(1, this.pageSize);
        if (!res) {
          return;
        }
      });
  }

  delete(ref:FatDoctoRef) {
    this.confirmService.confirm({ message: `Deseja realmente excluir a chave [${ref?.nfeRefChaveAcesso}]?` })
      .subscribe(res => {
        if (res) {
          this.fatDoctoCService.deleteDoctoRef(ref?.id).subscribe( s=> {
            this.confirmService.confirm(
              {
                title: `S U C E S S O  !`,
                message: `Docto Referenciado excluído com Sucesso !`,
                error: false
              }
            );
            this.getPage(1, this.pageSize);
          },
          (err) => {
            this.confirmService.confirm(
              {
                title: `A T E N Ç Ã O !`,
                message: `${err?.error.erro??'Erro ao excluir Docto ref'}`,
                error: true
              }
            );
          });
        }
      });
  }

  close() {
    this.dialogRef.close();
    // this.confirmService.confirm({ message: `Deseja realmente fechar? Poderá haver perda de dados.` })
    //   .subscribe(res => {
    //     if (res) {
    //       this.dialogRef.close();
    //     }
    //   });
  }

}
